var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "asc__showPage" }, [
    _c("div", { staticClass: "asc__showPage-times" }, [
      _c("i", {
        staticClass: "fas fa-times-circle",
        on: {
          click: function($event) {
            return _vm.closeQuick()
          }
        }
      })
    ]),
    _vm._v(" "),
    _vm.rowData
      ? _c(
          "div",
          { staticClass: "asc__showPage-container" },
          [
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c(
                    "header",
                    [
                      _c("Breadcrumb", {
                        attrs: { title: _vm.rowData.Description1 }
                      })
                    ],
                    1
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c("section", [
                    _c("span", [
                      _c("i", { staticClass: "fas fa-code" }),
                      _vm._v(" "),
                      _c("b", [_vm._v(_vm._s(_vm.$t("get.code")) + ":")]),
                      _vm._v(" " + _vm._s(_vm.rowData.Code))
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _c("i", { staticClass: "far fa-circle" }),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(_vm._s(_vm.$t("get.description1")) + ":")
                      ]),
                      _vm._v(" " + _vm._s(_vm.rowData.Description1))
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _c("i", { staticClass: "fas fa-check" }),
                      _vm._v(" "),
                      _c("b", [_vm._v(_vm._s(_vm.$t("get.status")) + ":")]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.rowData.StatusId
                              ? _vm.$t("insert.active")
                              : _vm.$t("insert.passive")
                          )
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _c("i", { staticClass: "far fa-circle" }),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.$t("insert.cancelReason.cardType")) + ":"
                        )
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.rowData.CardType
                              ? _vm.rowData.CardType.Label
                              : ""
                          )
                      )
                    ])
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f735ad6e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f735ad6e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CancelReason/get.vue
// module id = null
// module chunks = 